export interface DataInit {
  name: string;
  type: string;
  description: string;
  required: boolean;
}

export const code: DataInit[] = [
  {
    name: "app_id",
    type: "string",
    description: "The unique identifier of the application.",
    required: true,
  },
  {
    name: "app_key",
    type: "string",
    description: "The key used to encrypt the payload.",
    required: true,
  },
  {
    name: "app_secret",
    type: "string",
    description: "The secret key used to sign the payload.",
    required: true,
  },
  {
    name: "payload",
    type: "object",
    description: "The data to be sent to the server.",
    required: true,
  },
  {
    name: "timestamp",
    type: "number",
    description:
      "The current UNIX timestamp.This timestamp is to verify the request will not be replayed.",
    required: true,
  },
  {
    name: "nonce",
    type: "string",
    description: "A random string that should be unique.",
    required: true,
  },
];
